import React from 'react';
import { LayoutDashboard, Users, Megaphone, Star, Globe, User, Search, ChevronDown, Filter, Copy, Link2 } from 'lucide-react';
export const Sidebar = ({
  active
}: {
  active: string;
}) => {
  const menu = [{
    name: 'Dashboard',
    icon: LayoutDashboard
  }, {
    name: 'Roster Database',
    icon: Users
  }, {
    name: 'Casting Calls',
    icon: Megaphone
  }, {
    name: 'Talent Agencies',
    icon: Star
  }, {
    name: 'The Creator Network',
    icon: Globe,
    badge: 'New'
  }];
  return <div className="w-48 border-r border-gray-100 bg-white flex flex-col shrink-0 hidden md:flex" data-id="element-1344" data-mp="17q1iemzc1gk0">
      <div className="p-4" data-id="element-1345" data-mp="12rgjqrzqb4xo">
        <div className="text-xl font-extrabold text-zano-pink lowercase tracking-tight" data-id="element-1346" data-mp="12s8fq3x8n4oh">
          zano
        </div>
      </div>
      <div className="px-3 py-2 text-[10px] font-semibold text-gray-400 uppercase tracking-wider" data-id="element-1347" data-mp="323j9ul2uyxkb">
        Main Menu
      </div>
      <div className="space-y-0.5 px-2" data-id="element-1348" data-mp="3eqov2lrvb1ov">
        {menu.map(m => <div key={m.name} className={`flex items-center gap-2 px-2 py-1.5 rounded-md text-xs font-medium cursor-pointer ${active === m.name ? 'bg-pink-50 text-zano-pink' : 'text-gray-600 hover:bg-gray-50'}`} data-id="element-1349" data-mp="3epdt8rhzg40e">
            <m.icon size={14} className={active === m.name ? 'text-zano-pink' : 'text-gray-400'} data-id="element-1350" data-mp="39r2h2a47thf0" />
            <span className="truncate" data-id="element-1351" data-mp="1canoy46ciw1">{m.name}</span>
            {m.badge && <span className="ml-auto text-[8px] bg-pink-100 text-zano-pink px-1.5 py-0.5 rounded-sm" data-id="element-1352" data-mp="69k9m3scucf4">
                {m.badge}
              </span>}
          </div>)}
      </div>
    </div>;
};
export const Topbar = ({
  title,
  subtitle
}: {
  title: string;
  subtitle?: string;
}) => <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-white" data-id="element-1353" data-mp="k9v4dhwscb5k">
    <div data-id="element-1354" data-mp="p250xgseo9gt">
      <h1 className="text-lg font-bold text-gray-900" data-id="element-1355" data-mp="p2xvzki05aj4">{title}</h1>
      {subtitle && <p className="text-xs text-gray-500" data-id="element-1356" data-mp="ywalah8bnjga">{subtitle}</p>}
    </div>
    <div className="flex items-center gap-2" data-id="element-1357" data-mp="tyihaouek6vq">
      <div className="w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center text-gray-500" data-id="element-1358" data-mp="tys8ugv3im3j">
        <User size={12} data-id="element-1359" data-mp="oxl0ogp1jkwc" />
      </div>
      <span className="text-xs font-medium text-gray-700 hidden sm:inline" data-id="element-1360" data-mp="kxkluuy157or">
        Sapir Tori
      </span>
    </div>
  </div>;
export const MockupLayout = ({
  active,
  title,
  subtitle,
  children
}: any) => <div className="bg-gray-50 rounded-xl border border-gray-200 shadow-sm overflow-hidden flex h-[400px] text-left w-full" data-id="element-1361" data-mp="b813dqe8bfuf">
    <Sidebar active={active} data-id="element-1362" data-mp="67wmw0dbml47" />
    <div className="flex-1 flex flex-col overflow-hidden min-w-0" data-id="element-1363" data-mp="697lllrwt2og">
      <Topbar title={title} subtitle={subtitle} data-id="element-1364" data-mp="1acxq5f34nxh" />
      <div className="flex-1 overflow-auto p-4" data-id="element-1365" data-mp="17idoezzh54l">{children}</div>
    </div>
  </div>;
export const TTIco = () => <span className="text-[10px] font-bold" data-id="element-1366" data-mp="3tf6yvw99fn03">TT</span>;
export const IGIco = () => <span className="text-[10px] font-bold text-pink-500" data-id="element-1367" data-mp="3of2rqwu8s4mj">IG</span>;
export const YTIco = () => <span className="text-[10px] font-bold text-red-500" data-id="element-1368" data-mp="23vz1g25vln26">YT</span>;
export const DirectoryMockup = () => {
  const agencies = [{
    name: 'United Talent Agency',
    short: 'UTA',
    inf: '895',
    tt: '2B',
    ig: '1B',
    yt: '0',
    email: 'CreatorsBrandPartnerships@unitedtalent.com'
  }, {
    name: 'Clicks Talent',
    short: 'CT',
    inf: '886',
    tt: '393M',
    ig: '285M',
    yt: '917M',
    email: 'ab@clickstalent.com',
    link: true
  }, {
    name: 'Viral Nation Inc',
    short: 'VN',
    inf: '442',
    tt: '759M',
    ig: '274M',
    yt: '286M',
    email: 'ena@viralnation.com',
    link: true
  }, {
    name: 'Viral Hub Marketing',
    short: 'VH',
    inf: '190',
    tt: '38M',
    ig: '14M',
    yt: '8M',
    email: 'daniel@viralhubmarketing.com',
    link: true
  }, {
    name: 'Connect Management',
    short: 'CM',
    inf: '150',
    tt: '232M',
    ig: '57M',
    yt: '20M',
    email: 'oliver@connectmgt.com',
    link: true
  }];
  return <MockupLayout active="Talent Agencies" title="Talent Agencies" data-id="element-1369" data-mp="3469ti6ha9zfi">
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-1370" data-mp="3hwvd5xekadeg">
        <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-1371" data-mp="3d4v8jrnjqwbj">
          <thead className="bg-white border-b border-gray-100 text-gray-500" data-id="element-1372" data-mp="3ru1495n6e4eo">
            <tr data-id="element-1373" data-mp="3rw44eii1ldx4">
              <th className="px-3 py-2 font-medium" data-id="element-1374" data-mp="3muwwmjfwgeqg">Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1375" data-mp="3mueqmv3fqm5c">Influencers ↑</th>
              <th className="px-3 py-2 font-medium" data-id="element-1376" data-mp="4plcp1a92nc7">
                <TTIco data-id="element-1377" data-mp="4mz5j2r9u9ui" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1378" data-mp="ngl083d40s7">
                <IGIco data-id="element-1379" data-mp="lvowe1eg9s8" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1380" data-mp="26fwsihyda87j">
                <YTIco data-id="element-1381" data-mp="26ihvxbebcw7e" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1382" data-mp="22fv0z1mciv5z">Website</th>
              <th className="px-3 py-2 font-medium" data-id="element-1383" data-mp="22hfqudxptpxi">Email</th>
              <th className="px-3 py-2 font-medium" data-id="element-1384" data-mp="1sbod21dh1vai"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-1385" data-mp="1wbgd1posut49">
            {agencies.map((a, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1386" data-mp="1ika3f0rt3f3n" data-mpi={i}>
                <td className="px-3 py-2 flex items-center gap-2" data-id="element-1387" data-mp="1nkg1ayoo5xu6">
                  <div className="w-6 h-6 bg-gray-900 text-white rounded-full flex items-center justify-center text-[8px] font-bold shrink-0" data-id="element-1388" data-mp="1nilibpwykfsq">
                    {a.short}
                  </div>
                  <span className="font-medium text-gray-900" data-id="element-1389" data-mp="1dnjsssyrtbpm">{a.name}</span>
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1390" data-mp="zobppozhljg5">{a.inf}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1391" data-mp="14mlkhyhaui18">{a.tt}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1392" data-mp="2u0i9vdaczakl">{a.ig}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1393" data-mp="2u19u5ryi9lvk">{a.yt}</td>
                <td className="px-3 py-2 text-gray-400" data-id="element-1394" data-mp="2yyjw2732zq0a">
                  {a.link && <Link2 size={12} data-id="element-1395" data-mp="2wkohpw23fl6f" />}
                </td>
                <td className="px-3 py-2 text-gray-500 truncate max-w-[120px]" data-id="element-1396" data-mp="2wm9c9loer44a">
                  {a.email}
                </td>
                <td className="px-3 py-2 text-right" data-id="element-1397" data-mp="2nk8g6s4wuo47">
                  <div className="flex items-center justify-end gap-2" data-id="element-1398" data-mp="2nkrxq7qnfahp">
                    <Copy size={12} className="text-gray-400" data-id="element-1399" data-mp="2ilyk8fbd3jhj" />
                    <button className="border border-gray-200 text-gray-700 rounded px-2 py-1 text-[10px] font-medium bg-white" data-id="element-1400" data-mp="2inhw7tpzj8di">
                      View Roster
                    </button>
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </MockupLayout>;
};
export const CastingCallMockup = () => {
  const calls = [{
    name: 'Temu US campaign short form',
    budget: '$10,000 - $120,000',
    cat: '-',
    type: 'Paid Promo',
    plats: ['TT', 'IG'],
    posted: 'Braco US',
    date: 'Jun 26'
  }, {
    name: 'Kopouch World Cup Activation',
    budget: '$400 - $600',
    cat: '-',
    type: 'Paid Promo',
    plats: ['IG'],
    posted: 'Clicks Talent',
    date: 'Jun 4'
  }, {
    name: 'Leesa Summer',
    budget: '$42 - $6,000',
    cat: 'Beauty, Book Reviews...',
    type: 'Paid Promo',
    plats: ['YT'],
    posted: 'The Outloud Group',
    date: 'May 22'
  }, {
    name: 'DJI',
    budget: '-',
    cat: '-',
    type: 'Paid Promo',
    plats: ['IG'],
    posted: 'Clicks Talent',
    date: 'May 14'
  }];
  return <MockupLayout active="Casting Calls" title="Casting Calls" subtitle="24 Casting Calls" data-id="element-1401" data-mp="ta1o0tfsjnji">
      <div className="flex items-center justify-between mb-3" data-id="element-1402" data-mp="131xv2tzuunzv">
        <div className="flex items-center gap-3" data-id="element-1403" data-mp="134abh2pysqat">
          <button className="flex items-center gap-1 border border-gray-200 bg-white px-2 py-1 rounded text-xs font-medium text-gray-700" data-id="element-1404" data-mp="1823gvtjg1ga1">
            <Filter size={12} data-id="element-1405" data-mp="1c35iui4qw6fp" /> All filters
          </button>
          <button className="text-xs text-gray-500 underline" data-id="element-1406" data-mp="1xd2oo4aqy0b2">Clear all</button>
        </div>
        <button className="bg-pink-100 text-pink-600 px-3 py-1.5 rounded text-xs font-medium" data-id="element-1407" data-mp="1td0ltrt9z0u7">
          + New Casting Call
        </button>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-1408" data-mp="279xlmirdfsn8">
        <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-1409" data-mp="22dgq33huec04">
          <thead className="bg-white border-b border-gray-100 text-gray-500" data-id="element-1410" data-mp="1eoe7ntfdwf4k">
            <tr data-id="element-1411" data-mp="19orv7m7dr2wt">
              <th className="px-3 py-2 font-medium" data-id="element-1412" data-mp="19pb1g5no42v0">Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1413" data-mp="1od5u5m1oe783">Budget</th>
              <th className="px-3 py-2 font-medium" data-id="element-1414" data-mp="1oeqp3crwjs6h">Category</th>
              <th className="px-3 py-2 font-medium" data-id="element-1415" data-mp="1jm5y0j0drt6n">Type of Collaboration</th>
              <th className="px-3 py-2 font-medium" data-id="element-1416" data-mp="vwlf20488vxd">Platforms</th>
              <th className="px-3 py-2 font-medium" data-id="element-1417" data-mp="vv0glzesksu8">Posted By</th>
              <th className="px-3 py-2 font-medium" data-id="element-1418" data-mp="qwqpq103oeef">Date Posted</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-1419" data-mp="32k2i4vte1yd7">
            {calls.map((c, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1420" data-mp="37cvotp8f3grx" data-mpi={i}>
                <td className="px-3 py-2 font-medium text-gray-900 truncate max-w-[150px]" data-id="element-1421" data-mp="37dojvsy0khu8">
                  {c.name}
                </td>
                <td className="px-3 py-2 text-green-600 font-medium" data-id="element-1422" data-mp="2xl92awqmpv9v">
                  {c.budget}
                </td>
                <td className="px-3 py-2 text-gray-500 truncate max-w-[100px]" data-id="element-1423" data-mp="3lc4sjpffsif0">
                  {c.cat}
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1424" data-mp="3q8lp980pc53p">{c.type}</td>
                <td className="px-3 py-2 flex gap-1" data-id="element-1425" data-mp="3ca5dh2nzfoep">
                  {c.plats.includes('TT') && <TTIco data-id="element-1426" data-mp="3h8yp0pjpl5c8" />}
                  {c.plats.includes('IG') && <IGIco data-id="element-1427" data-mp="3hbuowjf4a43b" />}
                  {c.plats.includes('YT') && <YTIco data-id="element-1428" data-mp="20uyslok2nxtq" />}
                </td>
                <td className="px-3 py-2 text-gray-700 flex items-center gap-1" data-id="element-1429" data-mp="25uuw7mouxn8r">
                  <div className="w-4 h-4 bg-gray-200 rounded-full shrink-0" data-id="element-1430" data-mp="25sry0fdjwnsy"></div>
                  <span className="truncate max-w-[100px]" data-id="element-1431" data-mp="qxcmohqfrbkv">{c.posted}</span>
                </td>
                <td className="px-3 py-2 text-gray-500" data-id="element-1432" data-mp="uxwo3xi1l1ct">{c.date}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </MockupLayout>;
};
export const SubmissionsMockup = CastingCallMockup;
export const RosterDatabaseMockup = () => {
  const creators = [{
    name: 'Dr. Aamir Hussain',
    cat: 'Academia',
    country: 'United Kingdom',
    tt: '-',
    ig: '39.3K',
    yt: '2.9K',
    agency: 'KAW Management Group',
    excl: 'Non-Exclusive',
    email: 'connect@kawmanagementgroup.com'
  }, {
    name: 'Ganyah Goldstein',
    cat: 'Academia',
    country: 'United Kingdom',
    tt: '82.9K',
    ig: '38.1K',
    yt: '-',
    agency: 'Viral Hub Marketing',
    excl: 'Non-Exclusive',
    email: 'daniel@viralhubmarketing.com'
  }, {
    name: 'Julius Doyle',
    cat: 'Academia',
    country: 'United States',
    tt: '-',
    ig: '449.8K',
    yt: '-',
    agency: 'Clicks Talent',
    excl: 'Non-Exclusive',
    email: 'amaany@clickstalentagency.com'
  }, {
    name: 'Stephanie & Loreal',
    cat: 'Academia',
    country: 'United States',
    tt: '169.8K',
    ig: '456.8K',
    yt: '-',
    agency: 'Boost Society',
    excl: 'Exclusive',
    email: 'josh@boost-society.com'
  }];
  return <MockupLayout active="Roster Database" title="Roster Database" data-id="element-1433" data-mp="2lglchhjgir99">
      <div className="flex items-center gap-2 mb-3 overflow-x-auto pb-1" data-id="element-1434" data-mp="2lgcy1l7ordvy">
        <div className="relative flex-1 min-w-[120px]" data-id="element-1435" data-mp="2zfcishs2v8mu">
          <Search size={12} className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-1436" data-mp="2vesnzkuz8h3v" />
          <input type="text" placeholder="Search" className="w-full pl-6 pr-2 py-1 border border-gray-200 rounded text-xs outline-none" data-id="element-1437" data-mp="151l77cq6ueor" />
        </div>
        {['Platforms', 'Categories', 'Countries'].map(f => <button key={f} className="flex items-center gap-1 border border-gray-200 bg-white px-2 py-1 rounded text-xs text-gray-700 whitespace-nowrap" data-id="element-1438" data-mp="354mc08ywcawx">
            {f} <ChevronDown size={10} data-id="element-1439" data-mp="3a61w9yt92de9" />
          </button>)}
        <button className="flex items-center gap-1 border border-gray-200 bg-white px-2 py-1 rounded text-xs font-medium text-gray-700 whitespace-nowrap" data-id="element-1440" data-mp="3f4d7odz70vyl">
          <Filter size={12} data-id="element-1441" data-mp="3o36whi6a8i1l" /> All filters
        </button>
        <button className="text-xs text-gray-500 underline whitespace-nowrap" data-id="element-1442" data-mp="3o1nf1o8w40y8">
          Clear all
        </button>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-id="element-1443" data-mp="1nvyl90zivl7">
        <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-1444" data-mp="1pqbc023rhe7">
          <thead className="bg-white border-b border-gray-100 text-gray-500" data-id="element-1445" data-mp="6ojrk08rxmi2">
            <tr data-id="element-1446" data-mp="aplq0euv9uiz">
              <th className="px-3 py-2 font-medium" data-id="element-1447" data-mp="ap3l6tu527zg">Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1448" data-mp="1v74ecyul9qvg">Category ↓</th>
              <th className="px-3 py-2 font-medium" data-id="element-1449" data-mp="1v49tx7bks621">Country</th>
              <th className="px-3 py-2 font-medium" data-id="element-1450" data-mp="1r47yhfwfo8v7">
                <TTIco data-id="element-1451" data-mp="1m5odpitkt34f" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1452" data-mp="1m6pr3ty2e1pb">
                <IGIco data-id="element-1453" data-mp="1h73bxeyoebdv" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1454" data-mp="1h84yogp20mbf">
                <YTIco data-id="element-1455" data-mp="2euc57w4x4oqf" />
              </th>
              <th className="px-3 py-2 font-medium" data-id="element-1456" data-mp="2etaiguejidsv">Agency Name</th>
              <th className="px-3 py-2 font-medium" data-id="element-1457" data-mp="29uz88ikc21a4">Exclusivity</th>
              <th className="px-3 py-2 font-medium" data-id="element-1458" data-mp="29xv5e4ocwlxi">Contact Email</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50" data-id="element-1459" data-mp="252funllnb65b">
            {creators.map((c, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-1460" data-mp="203v3ebodfwt0" data-mpi={i}>
                <td className="px-3 py-2 flex items-center gap-2" data-id="element-1461" data-mp="2xlv71zn7hwqv">
                  <div className="w-5 h-5 bg-gray-200 rounded-full shrink-0" data-id="element-1462" data-mp="2stv03n8py3ks"></div>
                  <span className="font-medium text-gray-900 truncate max-w-[100px]" data-id="element-1463" data-mp="2dcd8ld7yd24i">
                    {c.name}
                  </span>
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1464" data-mp="2hfi6t3l02hnc">{c.cat}</td>
                <td className="px-3 py-2 text-gray-600 truncate max-w-[80px]" data-id="element-1465" data-mp="23ez4md37u5t3">
                  {c.country}
                </td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1466" data-mp="28dsg5zyxzmqm">{c.tt}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1467" data-mp="2w2l4ba9boqao">{c.ig}</td>
                <td className="px-3 py-2 text-gray-600" data-id="element-1468" data-mp="311y38tdgxntm">{c.yt}</td>
                <td className="px-3 py-2 text-gray-700 truncate max-w-[100px]" data-id="element-1469" data-mp="311eh10gscd9s">
                  {c.agency}
                </td>
                <td className="px-3 py-2 text-gray-500" data-id="element-1470" data-mp="2rc4sful5hcqf">{c.excl}</td>
                <td className="px-3 py-2 text-gray-500 flex items-center justify-between gap-2" data-id="element-1471" data-mp="2raa5ybu8dck8">
                  <span className="truncate max-w-[120px]" data-id="element-1472" data-mp="3f04ewibfigz7">{c.email}</span>
                  <Copy size={10} className="text-gray-400 shrink-0" data-id="element-1473" data-mp="3jth3isg3ynry" />
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </MockupLayout>;
};
export const InsightsMockup = () => {
  return <MockupLayout active="Dashboard" title="Dashboard" data-id="element-1474" data-mp="13c9diwagxiyj">
      <div className="space-y-4" data-id="element-1475" data-mp="1h4p8rax4ocow">
        <div data-id="element-1476" data-mp="1h4z4zg8rng31">
          <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-1477" data-mp="1h7l730cw13dv">
            Talent Agencies
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-1478" data-mp="pe2rcdevt7ep">
            {[{
            title: 'TikTok Top Agencies',
            icon: <TTIco data-id="element-1479" data-mp="khko5hz79h4h" />,
            data: [{
              n: 'United Talent Agency',
              v: '1,886,760,587'
            }, {
              n: 'Viral Nation Inc',
              v: '758,591,677'
            }]
          }, {
            title: 'Instagram Top Agencies',
            icon: <IGIco data-id="element-1480" data-mp="24xpb38tzn55e" />,
            data: [{
              n: 'United Talent Agency',
              v: '1,169,648,463'
            }, {
              n: 'Clicks Talent',
              v: '284,615,765'
            }]
          }, {
            title: 'YouTube Top Agencies',
            icon: <YTIco data-id="element-1481" data-mp="1gfbxvvwgwkk8" />,
            data: [{
              n: 'Clicks Talent',
              v: '916,534,313'
            }, {
              n: 'Viral Nation Inc',
              v: '286,009,190'
            }]
          }].map(col => <div key={col.title} className="bg-white border border-gray-200 rounded-lg p-3" data-id="element-1482" data-mp="xjvjxqq0rl9e">
                <div className="flex items-center gap-1 text-xs font-semibold text-gray-900 mb-3" data-id="element-1483" data-mp="1lsmltm3q90">
                  {col.icon} {col.title}
                </div>
                <div className="space-y-2" data-id="element-1484" data-mp="3tn392l1o7phm">
                  {col.data.map(d => <div key={d.n} className="flex justify-between items-center text-[10px]" data-id="element-1485" data-mp="3oqctrzxowxx9">
                      <div className="flex items-center gap-1" data-id="element-1486" data-mp="3fon0eok8zowu">
                        <div className="w-3 h-3 bg-gray-900 rounded-full shrink-0" data-id="element-1487" data-mp="3fodaf0z7dhr5"></div>
                        <span className="text-gray-700 truncate max-w-[80px]" data-id="element-1488" data-mp="3ar4qauuhv3n9">
                          {d.n}
                        </span>
                      </div>
                      <span className="text-gray-500 font-medium" data-id="element-1489" data-mp="30yyzvpjw4ua6">{d.v}</span>
                    </div>)}
                </div>
              </div>)}
          </div>
        </div>

        <div data-id="element-1490" data-mp="2rzbzn72wduip">
          <h3 className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" data-id="element-1491" data-mp="2rxr35bx0w1i7">
            Pricing
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-1492" data-mp="2n22alsjf7kve">
            {[{
            title: 'TikTok Pricing',
            icon: <TTIco data-id="element-1493" data-mp="jqm7wadz35gu" />,
            data: [{
              n: 'Video Post',
              v: '$7,746'
            }, {
              n: 'Link in Bio',
              v: '$5,378'
            }]
          }, {
            title: 'Instagram Pricing',
            icon: <IGIco data-id="element-1494" data-mp="ri1l9dtfpsv" />,
            data: [{
              n: 'Photo',
              v: '$7,102'
            }, {
              n: 'Reels',
              v: '$8,722'
            }]
          }, {
            title: 'YouTube Pricing',
            icon: <YTIco data-id="element-1495" data-mp="397tk71hhq9pr" />,
            data: [{
              n: 'Integration',
              v: '$6,196'
            }, {
              n: 'Dedication',
              v: '$8,995'
            }]
          }].map(col => <div key={col.title} className="bg-white border border-gray-200 rounded-lg p-3" data-id="element-1496" data-mp="33lazqpyl54kn">
                <div className="flex items-center gap-1 text-xs font-semibold text-gray-900 mb-3" data-id="element-1497" data-mp="2ziwg43n3e0sb">
                  {col.icon} {col.title}
                </div>
                <div className="space-y-2" data-id="element-1498" data-mp="38knjh1u5tvj0">
                  {col.data.map(d => <div key={d.n} className="flex justify-between items-center text-[10px]" data-id="element-1499" data-mp="3n9aa3zp8m9pj">
                      <span className="text-gray-600" data-id="element-1500" data-mp="3iapao2ht7u25">{d.n}</span>
                      <span className="text-green-600 font-medium" data-id="element-1501" data-mp="3srwiitbxk8">{d.v}</span>
                    </div>)}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </MockupLayout>;
};
export const MediaKitLinkMockup = () => <MockupLayout active="Talent Agencies" title="Media Kits" data-id="element-1502" data-mp="3mw2cz07fmp3">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1503" data-mp="3mcl7kidp2c4">
      <div className="border-b border-gray-100 p-4 flex items-center gap-2 bg-gray-50/50" data-id="element-1504" data-mp="hlvifi9nit9n">
        <Link2 size={16} className="text-gray-500" data-id="element-1505" data-mp="cntxerso0jvj" />
        <span className="font-semibold text-sm text-gray-800 flex-1" data-id="element-1506" data-mp="3l2uekqqda84h">
          zano.co/agency/uta
        </span>
        <span className="text-xs text-zano-pink font-medium" data-id="element-1507" data-mp="3g4skzbvbeqer">Copy link</span>
      </div>
      <div className="px-4 pt-3 flex items-center gap-2" data-id="element-1508" data-mp="3usnhz4gcvgxn">
        <div className="flex-1 bg-gray-50 border border-gray-200 rounded-md px-2.5 py-1 text-xs text-gray-400 flex items-center gap-1" data-id="element-1509" data-mp="3uu8cwv6l11w1">
          <Search size={11} data-id="element-1510" data-mp="32ccqx0ke62pz" /> Filter by followers, niche, location…
        </div>
      </div>
      <div className="p-4 grid grid-cols-2 gap-3" data-id="element-1511" data-mp="2xdt28seeyctx">
        {[1, 2].map(c => <div key={c} className="border border-gray-100 rounded-lg p-3" data-id="element-1512" data-mp="2xboz4coc9hup">
            <div className="w-10 h-10 bg-gray-200 rounded-full mb-2" data-id="element-1513" data-mp="1cu62l5egqf75"></div>
            <div className="flex items-center gap-1.5" data-id="element-1514" data-mp="1hn8wjen5jqnv">
              <p className="text-sm font-semibold text-gray-900" data-id="element-1515" data-mp="13ussqbmffolw">
                Creator Name
              </p>
            </div>
            <p className="text-xs text-gray-500" data-id="element-1516" data-mp="17vmh163s75fb">1.2M • 4.8% ENG</p>
          </div>)}
      </div>
    </div>
  </MockupLayout>;
export const MediaKitMockup = () => <MockupLayout active="Talent Agencies" title="Creator Profile" data-id="element-1517" data-mp="20l321ip2nk1i">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1518" data-mp="20ka5fajtuax3">
      <div className="bg-gray-50 border-b border-gray-200 p-4 flex items-center gap-3" data-id="element-1519" data-mp="1mks9mb845xe8">
        <div className="w-12 h-12 bg-gray-200 rounded-full" data-id="element-1520" data-mp="1rj25ko1nx20w"></div>
        <div data-id="element-1521" data-mp="b5luzeusr31p">
          <h4 className="font-bold text-gray-900" data-id="element-1522" data-mp="b5vhutkjou36">Elena Rodriguez</h4>
          <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-1523" data-mp="g4yfhsy73y14">
            <Globe size={12} data-id="element-1524" data-mp="g358gcjo7bsl" /> LA • UTA
          </p>
        </div>
      </div>
      <div className="p-4 grid grid-cols-3 gap-3" data-id="element-1525" data-mp="2htvy6soevwqp">
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1526" data-mp="2cvkoqj213o90">
          <p className="text-[10px] text-gray-500 uppercase" data-id="element-1527" data-mp="2cxnc0vbsr3a1">Followers</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-1528" data-mp="2831arkzfir3o">1.2M</p>
        </div>
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1529" data-mp="241xx954ut75m">
          <p className="text-[10px] text-gray-500 uppercase" data-id="element-1530" data-mp="1z4fjn1fw63ra">Avg views</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-1531" data-mp="1z1jo1jrinr60">340K</p>
        </div>
        <div className="bg-gray-50 rounded-lg p-3 border border-gray-100" data-id="element-1532" data-mp="1u3i30taj5hrw">
          <p className="text-[10px] text-gray-500 uppercase" data-id="element-1533" data-mp="1p6hxqkli8j1u">Eng.</p>
          <p className="text-lg font-bold text-gray-900" data-id="element-1534" data-mp="1l4muvbnxdxly">4.8%</p>
        </div>
      </div>
    </div>
  </MockupLayout>;
export const RosterMockup = () => <MockupLayout active="Talent Agencies" title="Your Roster" data-id="element-1535" data-mp="3jiy9g0x2kpe3">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1536" data-mp="3fj7dlisorj2p">
      <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex justify-between items-center" data-id="element-1537" data-mp="11b6fmxs17j3f">
        <span className="font-semibold text-sm text-gray-800" data-id="element-1538" data-mp="168ofzzrzgpzt">Your Roster</span>
        <span className="text-xs text-zano-pink font-medium" data-id="element-1539" data-mp="1b0g669788tpf">
          + Add creator
        </span>
      </div>
      <div className="p-4 grid grid-cols-2 gap-4" data-id="element-1540" data-mp="1f21hvr80z1y1">
        <div className="border border-gray-100 rounded-lg p-3 bg-gray-50" data-id="element-1541" data-mp="1f3w2f4fdws1l">
          <p className="text-xs text-gray-500 mb-1" data-id="element-1542" data-mp="id3mc6sgazzt">Active roster</p>
          <p className="text-xl font-bold text-gray-900" data-id="element-1543" data-mp="n9u18qsirpjn">42</p>
        </div>
        <div className="border border-gray-100 rounded-lg p-3 bg-gray-50" data-id="element-1544" data-mp="rc78xkqttxj2">
          <p className="text-xs text-gray-500 mb-1" data-id="element-1545" data-mp="reblss6pe6vh">Casting inbound</p>
          <p className="text-xl font-bold text-gray-900" data-id="element-1546" data-mp="wc3a7c853aux">18</p>
        </div>
      </div>
    </div>
  </MockupLayout>;
export const PartnerRosterMockup = () => <MockupLayout active="Talent Agencies" title="Partner Agencies" data-id="element-1547" data-mp="27q74ykmjx311">
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-1548" data-mp="27sjt5fiwk9mj">
      <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex items-center gap-2" data-id="element-1549" data-mp="269jucpjm4r1d">
        <span className="font-semibold text-sm text-gray-800" data-id="element-1550" data-mp="21c1j2si4hzq7">
          My partner agencies
        </span>
      </div>
      <div className="px-4 pt-3 flex gap-1.5" data-id="element-1551" data-mp="2f7n46ol8jzdc">
        {['UTA', 'Viral Nation', 'Fixated'].map(a => <span key={a} className="text-[10px] text-zano-pink bg-zano-blush rounded-full px-2 py-0.5 font-medium" data-id="element-1552" data-mp="2baqzshya9e4v">
            {a}
          </span>)}
      </div>
      <div className="p-4 space-y-3" data-id="element-1553" data-mp="2yxz6n4bd0v90">
        {[1, 2].map(c => <div key={c} className="flex items-center justify-between p-3 border border-gray-100 rounded-lg" data-id="element-1554" data-mp="2yx5vlr5dbjl2">
            <div className="flex items-center gap-3" data-id="element-1555" data-mp="37ydsc4s8kcd1">
              <div className="w-9 h-9 bg-gray-200 rounded-full" data-id="element-1556" data-mp="37yx0its33mdv"></div>
              <div data-id="element-1557" data-mp="330lr2k5pbdw6">
                <p className="text-sm font-semibold text-gray-900" data-id="element-1558" data-mp="33157txjm7w8m">
                  Creator {c}
                </p>
                <p className="text-xs text-gray-500" data-id="element-1559" data-mp="3mj9i2igkvp77">Agency • live roster</p>
              </div>
            </div>
            <span className="text-xs bg-green-50 text-green-700 border border-green-200 px-2 py-0.5 rounded-full" data-id="element-1560" data-mp="3dko5r51p96ev">
              Updated
            </span>
          </div>)}
      </div>
    </div>
  </MockupLayout>;